export default __webpack_public_path__ + "media/images/dl-bg-e7f0226e8453fe4d8b26e25c5437593b.jpg";